import { ExamReportType } from '../../api/exam-report';
import { BLANK_TEXT } from '../../utils';

export type ExamReportsPropsType = {
  examReports: ExamReportType[];
};

function ExamReports({ examReports }: ExamReportsPropsType) {
  return (
    <div className='my-2 mx-auto w-full max-w-5xl'>
      <p className='my-6 text-center font-bold'>کارنامه تحلیلی به تفکیک زیر‌گروه‌ آموزشی</p>
      <table className='mx-auto w-full max-w-5xl table-auto'>
        <thead>
          <tr className='bg-sky-100 text-center'>
            <th className='border border-zinc-800 p-0.5 font-medium xs:p-1'>
              <span>زیر‌گروه </span>
              <span className='hidden xs:inline'>آموزشی</span>
            </th>
            {['درصد', 'تراز', 'رتبه'].map(header => (
              <th key={header} className='border border-zinc-800 p-0.5 font-medium xs:p-1'>
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {examReports.map(({ id, eduSubGroup, score, rank, scaledScore }) => {
            return (
              <tr key={id} className='hover:bg-sky-50'>
                <td className='border border-zinc-800 text-center'>{eduSubGroup?.name || '---'}</td>
                <td dir='ltr' className='border border-zinc-800 text-center'>
                  <span>{score}</span>
                  <span className='hidden xs:inline'>%</span>
                </td>
                <td className='border border-zinc-800 text-center'>{scaledScore || BLANK_TEXT}</td>
                <td className='border border-zinc-800 text-center'>{rank || BLANK_TEXT}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default ExamReports;
